export default __webpack_public_path__ + "07d37076b25b6b257674d8fd0c3a31c9.svg";